import { Vector2Tuple } from 'three';

import { FCompositionShallowNode } from '@spazious/dollhouse-shallow-graph';

import { FArrangement } from '../farrangements/types.js';
import { FEnsemble } from '../fensembles/index.js';
import { FCompositionNode, FNodeTypesEnum } from '../types/index.js';

import { BaseNodeImpl } from './BaseNode.js';

export class FCompositionNodeImpl extends BaseNodeImpl implements FCompositionNode {
  type: FNodeTypesEnum.FComposition = FNodeTypesEnum.FComposition;
  shallow: FCompositionShallowNode | null = null;
  id: number = 0;
  name: string = '';
  position: Vector2Tuple = [0, 0];
  rotation: number = 0;
  instance!: FEnsemble | FArrangement;
  attrs: Record<string, any> = {};
  visible: boolean = true;
  get outline2D() {
    return this.instance.outline2D;
  }
  computeOutline2D() {
    this.instance.computeOutline2D();
  }
  toJSON(recursive?: boolean) {
    return {
      ...super.toJSON(recursive),
      id: this.id,
      name: this.name,
      position: this.position,
      rotation: this.rotation,
      instance: this.instance.toJSON(),
      visible: this.visible,
      shallow: this.shallow,
    };
  }
}
